module.exports = __webpack_public_path__ + "static/media/spice.5723c391.png";